<template>
  <div id="app" :class="$route.path == '/checks' ? 'appfix' :'apprel'">
    <!--通用头部-->
    <keep-alive></keep-alive>
    <div class="head">
      <div class="warp">
        <div class="headImg">
          <img src="./assets/vvc.svg" alt @click="tohome">
        </div>
        <div class="RouText">
          <router-link
            @mouseenter.native="naventer(0,$event)"
            @mouseleave.native="navleave"
            :style="roulinkcol==0 ?'color:#57C6EB':''"
            to="/"
            exact
          >{{$t('data.headText.pageOne.name')}}</router-link>

          <router-link
            v-for="(item,index) in classlist"
            :key="index"
            @mouseenter.native="naventer(index+1,$event)"
            @mouseleave.native="navleave"
            :style="roulinkcol==index+1 ?'color:#57C6EB':''"
            :to="{path:'/integration',query:{'id':index,bannerid:item.child ? item.child[0].child[0].id : ''}}"
            :id="index"
          >
            {{item.title}}
            <div
              :style="roulinkcol==index+1 ?'display:block':''"
              style="background:rgba(255,255,255,.9)"
            >
              <p>{{$t('data.headText.classlist.title')}}</p>
              <ul class="navone" v-if="naventerlist.child">
                <li class="leftimg">
                  <img :src="item.img+'?x-oss-process=image/resize,h_1000'" alt>
                </li>
                <li class="navoneul" v-for="(item,index) in naventerlist.child" :key="index">
                  <ul class="navtow" v-if="item">
                    <span>{{item.title}}</span>

                    <li
                      v-for="(itemchild,index) in item.child"
                      :key="index"
                      @click="part(itemchild.id,itemchild.title,item.child)"
                    >{{itemchild.title}}</li>
                  </ul>
                </li>
              </ul>
            </div>
          </router-link>

          <router-link
            @mouseenter.native="naventer(4,$event)"
            @mouseleave.native="navleave"
            :style="roulinkcol==4 ?'color:#57C6EB':''"
            to="/vision"
          >{{$t('data.headText.pageFive.name')}}</router-link>
          <router-link
            @mouseenter.native="naventer(5,$event)"
            @mouseleave.native="navleave"
            :style="roulinkcol==5 ?'color:#57C6EB':''"
            to="/joint"
          >{{$t('data.headText.pageSix.name')}}</router-link>
          <router-link
            @mouseenter.native="naventer(6,$event)"
            @mouseleave.native="navleave"
            :style="roulinkcol==6 ?'color:#57C6EB':''"
            to="/checks"
          >{{$t('data.headText.pageSeven.name')}}</router-link>
        </div>
        <div class="language">
          <span @click="tablan(0)">中文</span>
          <span>|</span>
          <span @click="tablan(1)">EN</span>
          <span>|</span>
          <span @click="tablan(2)">언문</span>
        </div>
      </div>
    </div>

    <!--通用头部-->

    <!--路由内容-->
    <div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <!--路由内容-->

    <!--通用底部-->
    <div style="background:#fff;width:1920px;margin:0 auto">
      <footer style="background:#fff;width:100%">
        <div class="aboutText">
          <div class="aboutImg">
            <div>
              <img src="../src/assets/vvcLogo.svg" alt>
            </div>
          </div>
          <div class="aboutDivAll">
            <div class="aboutDiv">
              <div>{{$t('data.headText.foot.vvname')}}</div>
              <div>{{$t('data.headText.foot.ygkp')}}</div>
              <div>{{$t('data.headText.foot.vvcfz')}}</div>
              <div>{{$t('data.headText.foot.zlbl')}}</div>
              <div>{{$t('data.headText.foot.ppsm')}}</div>
            </div>
            <div class="aboutDiv">
              <div>{{$t('data.headText.foot.crfs')}}</div>
              <div>{{$t('data.headText.foot.nxfs')}}</div>
              <div>{{$t('data.headText.foot.nvfs')}}</div>
            </div>
            <div class="aboutDiv">
              <div>{{$t('data.headText.foot.etfs')}}</div>
            </div>
            <div class="aboutDiv">
              <div>{{$t('data.headText.foot.lmhz')}}</div>
              <div>{{$t('data.headText.foot.mxlik')}}</div>
              <div>{{$t('data.headText.foot.atls')}}</div>
              <div>{{$t('data.headText.foot.msd')}}</div>
            </div>
            <div class="aboutDiv">
              <div>{{$t('data.headText.foot.fwcx')}}</div>
              <div>
                <a href="#" @click="tochecks(0)">{{$t('data.headText.foot.dlcx')}}</a>
              </div>
              <div>
                <a href="#" @click="tochecks(1)">{{$t('data.headText.foot.fcx')}}</a>
              </div>
              <div>
                <a href="#" @click="tochecks(2)">{{$t('data.headText.foot.tbtmcx')}}</a>
              </div>
            </div>
          </div>
          <div>
            <div class="zixText">{{$t('data.headText.foot.zxrx')}}</div>
          </div>
        </div>
        <div class="versionAll">
          <div class="version">Copyright &#169 2020 VVC FEDERAL INTERNATIONAL CO. LIMITED</div>
          <div>
            <!--<img src="./assets/Bitmap(2).png" height="36" width="36"/>-->
            <!--<img src="./assets/Bitmap(3).png" height="36" width="36"/>-->
            <img src="./assets/Bitmap1.svg" height="36" width="36">
            <img src="./assets/Bitmap.svg" height="36" width="36">
            <img src="./assets/Bitmap2.svg" height="36" width="36">
            <img src="./assets/Bitmap4.svg" height="36" width="36">
          </div>
        </div>
      </footer>
    </div>
    <!--通用底部-->
  </div>
</template>
<script>
import axios from "axios";
import Bus from "./bus/index";
export default {
  name: "App",
  data() {
    return {
      locale: "en",
      changeLoc: "en",
      classlist: null,
      roulinkcol: -1,
      naventerlist: {},
      hearimg: ""
    };
  },
  beforeCreate () {
    // this.parts();
  },
  methods: {
    // ajax(){
    //   this.axios.post('http://jd1.vvc.tw/index/index/getBannerAll').then((res)=>{
    //     console.log(res);
    //   })
    // }
    parts() {
      this.req.post("http://jd1.vvc.tw/index/goods/getMenuAll").then(res => {
        if (res.data.code == 1) {
          this.classlist = res.data.data.menu;
          Bus.$emit("muen", this.classlist);
          //  console.log(this)
          var data = JSON.stringify(res.data.data.menu);
          var goods = JSON.stringify(res.data.data.goods);
          localStorage.setItem("muenall", data);
          localStorage.setItem("goodsall", goods);

        }
      });
    },
    tablan(i) {
      this.languageid= +i
      localStorage.setItem("language", i);
      if (i == 0) {
        this.$i18n.locale = "zh";
        localStorage.setItem("languageAll", "zh");
      }
      if (i == 1) {
        this.$i18n.locale = "en";
        localStorage.setItem("languageAll", "en");
      }
      if (i == 2) {
        this.$i18n.locale = "ko";
        localStorage.setItem("languageAll", "ko");
      }
      console.log(this.$router);
      // this.req.post('http://jd1.vvc.tw/index/index/setLanguage',this.qs.stringify({
      //   language: localStorage.getItem('language')
      // })).then((res) => {
      //   if (res.data.code == 1) {
      //     // this.parts()
      //   }
      // })
      this.$router.push("/");

      this.parts()
      setTimeout(()=>{

        window.location.reload()
      },100)



    },
    changes() {
      if (!localStorage.getItem("languageAll", "zh")) {
        localStorage.setItem("languageAll", "zh");
        window.location.reload();
      }
    },
    naventer(index, event) {
      this.roulinkcol = index;
      console.log(this.classlist);
      if (event.target.id != "") {
        this.naventerlist = this.classlist[event.target.id];
      }
      console.log(this.naventerlist);
    },
    navleave() {
      this.roulinkcol = -1;
    },
    part(i, a, c) {
      console.log(i);
      console.log(a);
      console.log(c);
      this.req
        .post(
          "http://jd1.vvc.tw/index/goods/getGoodsAll",
          this.qs.stringify({
            pid: i
          })
        )
        .then(res => {
          if (res.data.code == 1) {
            console.log(res.data.data.data);
            Bus.$emit("val", {
              data: res.data.data.data,
              id: i,
              clothesBuid: c
            });
            // for (var i in this.clothesMsg) {
            //   if (!(JSON.parse(this.clothesMsg[i].img) == null)) {
            //     var sss = JSON.parse(this.clothesMsg[i].img);
            //     // this.clothesImg =  JSON.parse(this.clothesMsg[i].img)[0]
            //     this.clothesImg.push(sss[0])
            //     // console.log(JSON.parse(this.clothesMsg[i].i
            //     // console.log(this.clothesImg);mg)[0]);
            //   }
            //   // console.log();
            // }
            // console.log(this.clothesImg);
            // console.log(this.clothesMsg);
          }
        });
    },
    tohome() {
      this.$router.push("/");
    },
    tochecks(id) {
      this.$router.push({ path: "/checks", query: { id: id } });
    }
  },
  watch: {
    // locale (val) {
    //   // 使用V-model 双向绑定 locale
    //   //watch locale 的更改  调用根实例的i18n 注意点，要加$符号
    //   this.$i18n.locale = val
    // }
    "$route.query"(data) {
      console.log(data);
    },
    $route(to) {
      // var domapp =document.getElementById('app')
      //  console.log(this.$route)
      //  console.log(document.body.clientWidth)
      // if(this.$route.path=='/checks' && document.body.clientWidth < 800){
      //   domapp.className="appfix"
      // }else{
      //   domapp.className="apprel"
      // }
    }
  },
  created() {
    this.parts();
    // this.changes();

    var domapp = document.getElementById("app");
    console.log(this.$route);
    if (this.$route.path == "/checks") {
      domapp.className = "appfix";
    } else {
      domapp.className = "apprel";
    }

    // this.tablan(0)
    // this.$store.dispatch('getlangCn'),
    //   setTimeout(()=>{
    //     console.log(this.data);
    //   },1000)
    // this.ajax()
    // this.tablan()
  },
  updated() {
    // this.chenggelan()
  },
  computed: {
    data() {
      // console.log(1);
      // console.log(this.$store.state.data);
      // return   this.$store.state
    }
  }
};
</script>

<style lang="stylus" scoped>
@media screen and (max-width: 750px) {
  #app {
    // position absolute
    // top 0
    // left 0
    // right 0
    // bottom 0
  }
}

.apprel {
  position: absolute !important;
}

.appfix {
  position: fixed !important;
}

body, div, span, ul, li, a, footer, img, html, h1, p {
  margin: 0;
  padding: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

::-webkit-scrollbar {
  display: none;
}

.headImg {
  cursor: pointer;
}

.RouText {
  a {
    display: inline-block;
    text-decoration: none;
    padding-right: 64px;
    font-size: 20px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(74, 74, 74, 1);
    text-align: center;

    // position relative
    div {
      position: absolute;
      z-index: 3;
      top: 86px;
      left: 0;
      display: none;
      background: rgba(255, 255, 255, 0.95);
      width: 1920px;
      height: 338px;
      padding-left: 378px;
      box-sizing: border-box;
      padding-top: 33px;
      background-position: center top;
      background-size: cover;

      p {
        font-size: 24px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 33px;
        text-align: left;
        padding-bottom: 22px;
      }

      .navone {
        width: 1920 -378px;
        height: 250px;
        display: flex;
      }

      li {
        list-style: none;

        span {
          font-size: 20px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: rgba(74, 74, 74, 1);
          line-height: 28px;
          margin-bottom: 16px;
          display: inline-block;
        }
      }
    }

    .leftimg {
      width: 225px;
      height: 165px;
      overflow: hidden;
      display: flex;
      align-items: center;
      margin-right: 69px;

      img {
        width: 100%;
        height: auto;
      }
    }

    .navoneul {
      margin-right: 90px;
    }

    .navtow {
      height: 100%;
      line-height: 32px;
      color: rgba(74, 74, 74, 1);
      font-size: 16px;
      text-align: left;

      li:hover {
        color: #57C6EB;
      }
    }
  }
}

.head {
  line-height: 86px;
  z-index: 1;
  width: 100%;
  height: 86px;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px -1px 0px 0px rgba(215, 215, 215, 1);
  border-bottom: 1px solid #ddd;

  .language {
    span {
      font-size: 20px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(74, 74, 74, 1);
      cursor: pointer;
    }
  }
}

.aboutText {
  display: flex;
  max-width: 1920px;
  margin: 0 auto;
  justify-content: space-around;
  margin-top: 47px;
}

footer {
  background: rgba(243, 243, 243, 1);
  border-top: 1px solid transparent;
}

.aboutDivAll {
  display: flex;

  .aboutDiv {
    width: 218px;

    div {
      min-height: 30px;
      font-size: 18px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #9b9b9b;
      // line-height: 40px;
      padding-bottom: 10px;

      a {
        text-decoration: none;
        color: #9b9b9b;
      }

      &:nth-child(1) {
        height: 70px;
        font-size: 20px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(74, 74, 74, 1);
        line-height: 28px;
        padding-bottom: 42px;
        box-sizing: border-box;
      }
    }
  }
}

.zixText {
  font-size: 20px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
}

.versionAll {
  height: 77px;
  line-height: 77px;
  border-top: 1px #ddd solid;
  margin: 0 auto;
  padding: 0 125px;
  max-width: 1920px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  img {
    margin-left: 24px;
  }
}

.version {
  font-size: 14px;
  font-family: SFUIText-Regular;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
}

.warp {
  height: 86px;
  margin: 0 auto;
  max-width: 1920px;
  display: flex;
  position: relative;
  justify-content: space-around;
  min-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue